/**
 * Normalise un scoreBreakdown vers l'échelle 0-100.
 *
 * L'IA a parfois renvoyé des sous-notes /20 (somme = score global)
 * au lieu de /100 (moyenne = score global).
 */
export function normalizeScoreBreakdown(breakdown, totalScore) {
  if (!breakdown || typeof breakdown !== 'object' || Array.isArray(breakdown)) {
    return breakdown;
  }

  const numericEntries = Object.entries(breakdown)
    .filter(([, value]) => {
      const n = typeof value === 'number' ? value : Number(value);
      return Number.isFinite(n);
    })
    .map(([key, value]) => [key, typeof value === 'number' ? value : Number(value)]);
  if (numericEntries.length === 0) {
    return breakdown;
  }

  const values = numericEntries.map(([, value]) => value);
  const max = Math.max(...values);
  const clamp = (n) => Math.min(100, Math.max(0, Math.round(n)));

  const apply = (transform) => ({
    ...breakdown,
    ...Object.fromEntries(
      numericEntries.map(([key, value]) => [key, clamp(transform(value))])
    ),
  });

  if (max > 20) {
    return apply((value) => value);
  }

  const sum = values.reduce((acc, value) => acc + value, 0);
  const avg = sum / values.length;
  const score =
    typeof totalScore === 'number' && Number.isFinite(totalScore)
      ? totalScore
      : null;
  const looksLikeAverage =
    score != null && Math.abs(avg - score) <= 5 && Math.abs(sum - score) > 5;

  if (looksLikeAverage) {
    return apply((value) => value);
  }

  return apply((value) => value * 5);
}

export function scoreBarColorClass(val) {
  if (val >= 70) return 'bg-green-500';
  if (val >= 40) return 'bg-amber-400';
  return 'bg-red-400';
}
